import { Button } from "antd";
import { Link } from "react-router-dom";
import FacebookIcon2 from "../../../assets/web/icons/FacebookIcon2";
import LinkedinIcon2 from "../../../assets/web/icons/LinkedinIcon2";
import LinkIcon from "../../../assets/web/icons/LinkIcon";
import TwitterIcon from "../../../assets/web/icons/TwitterIcon";
import Avatar from "../../../assets/web/images/avatar-placeholder.png";
import StoryDetailsBanner from "../../../assets/web/images/story-details-banner.png";
import BlurredCircle from "../../../components/web/BlurredCircle";
import StoryCard from "../../../components/web/common/StoryCard";
import Container from "../../../components/web/Container";
import PublicLayout from "../../../layouts/PublicLayout";

export default function StoriesDetails() {
  return (
    <PublicLayout title="Details | Sheba Business Portal">
      <Container>
        <BlurredCircle />
        <div className="max-w-4xl mx-auto mb-10">
          <div className="flex justify-between items-center py-10">
            <div className="flex gap-2">
              <div>
                <img src={Avatar} alt="Avatar" />
              </div>
              <div className="flex flex-col">
                <span className="text-[#2D3643]">Sheba Business</span>
                <div className="flex gap-2 text-[#5E718D]">
                  <span>Sen 22, 2020</span>
                  <span className="w-1 h-1 bg-[#5E718D] rounded-full top-[50%] relative -translate-y-[50%]"></span>
                  <span>2 Min read</span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span>Share:</span>
              <span>
                <FacebookIcon2 />
              </span>
              <span>
                <TwitterIcon />
              </span>
              <span>
                <LinkedinIcon2 />
              </span>
              <span>
                <LinkIcon />
              </span>
            </div>
          </div>
          <div className="text-4xl mb-2 md:text-[48px] leading-[50px] font-bold">
            digiGO Won Bangladesh Innovation Award 2022
          </div>
          <div>
            <img
              src={StoryDetailsBanner}
              alt="StoryDetailsBanner"
              className="w-full"
            />
          </div>
          <div className="py-10">
            <div>
              Managing employees is easier than ever since. digiGO has
              revolutionized the HR management of Bangladesh. For its innovative
              endeavor, HR software digiGO has won the Bangladesh Innovation
              Award 2022 in the category of Best Process Innovation.
            </div>
            <div className="mt-2">
              Bangladesh Innovation Award 2022 is organized by Bangladesh
              Innovation Conclave and Bangladesh Brand Forum. More than 120
              organizations have participated in this competition with more than
              250 nominations. Hence, it’s a significant event to encourage the
              innovative technologies of Bangladesh.
            </div>
            <div className="mt-2">
              Salman F. Rahman, MP, Private Industry and Investment Adviser to
              the Hon'ble Prime Minister, embellished the chair of chief guest.
              Apart from this, Mr. Zunaid Ahmed Palak, MP, Honorable State
              Minister, ICT Division, and Atiqul Islam, Honorable Mayor, Dhaka
              North City Corporation were special guests in that event.
            </div>
            <div className="mt-2">
              Isa Abrar Ahmed, Vice President of sBusiness said, "digiGO has
              recently made a huge transformation in the corporate industry of
              Bangladesh through which employees are becoming more productive
              and efficient."
            </div>
            <div className="mt-2">
              For the very first time HR software digiGO has automated the HR
              tasks in Bangladesh in the most efficient ways. Attendance,
              payroll, leave, expenses and other HR tasks can be done in the
              blink of an eye. For this paramount contribution, digiGO has been
              honored by the Bangladesh Innovation Award 2022. This marvelous
              achievement has energized sBusiness to move forward.
            </div>
            <div className="mt-2">
              This is a remarkable step to digital Bangladesh where digiGO is
              playing an important role. digiGO is for a better tomorrow.
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <div className="text-2xl font-bold">Recent Stories</div>
              <Button type="link" className="text-webPrimary">
                See all
              </Button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {[...Array(3)].map((_, index) => (
                <Link to="details">
                  <StoryCard key={index} />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </PublicLayout>
  );
}
